import { render, staticRenderFns } from "./HomepageVariants.vue?vue&type=template&id=6868bce3&"
import script from "./HomepageVariants.vue?vue&type=script&lang=js&"
export * from "./HomepageVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomepageVariants.vue"
export default component.exports